import { Link, useSearchParams } from "react-router-dom";
import { staff } from "../domain/data";
import {
  localDevShortcutsEnabled,
  pathKeepingDebug,
  runtimeFromBrowser,
} from "../domain/env";
import { useAuth } from "../state/AuthProvider";
import { LanguageToggle, useLocale } from "../state/i18n";
import { BrandMark, PrototypeBanner, SessionControl } from "../components/ui";

export function Gate() {
  const { t } = useLocale();
  const [params] = useSearchParams();
  const search = `?${params.toString()}`;
  const { account, session } = useAuth();
  const showDevShortcuts = localDevShortcutsEnabled(
    runtimeFromBrowser().name,
    search,
  );
  const parent = Boolean(session && account?.role === "parent");
  const otherAccount = Boolean(session && account && account.role !== "parent");
  const registerTo = parent
    ? "/register"
    : pathKeepingDebug("/signin", search, { next: "/register" });
  return (
    <div className="app">
      <PrototypeBanner />
      <main className="shell">
        <div className="gate-hero">
          <BrandMark size="hero" />
          <div className="gate-tools">
            <LanguageToggle size="hero" />
            <SessionControl when="signedIn" size="hero" />
          </div>
        </div>
        <div className="gate-copy">
          <p>{t("gate.body1")}</p>
          <p>{t("gate.body2")}</p>
          <p>{t("gate.body3")}</p>
        </div>

        {otherAccount ? null : (
          <div className="chooser chooser--primary">
            <Link to={registerTo}>
              <div>
                <div className="meta">{t("gate.registerMeta")}</div>
                <h2 style={{ margin: "0.35rem 0" }}>{t("gate.registerTitle")}</h2>
                <p style={{ margin: 0 }}>
                  {t(parent ? "gate.registerBodyReady" : "gate.registerBody")}
                </p>
              </div>
              <div className="anno">
                {t(parent ? "gate.registerCtaReady" : "gate.registerCta")}
              </div>
            </Link>
          </div>
        )}
        <div className="chooser">
          <Link to={pathKeepingDebug("/signin", search)}>
            <div>
              <div className="meta">{t("gate.familyMeta")}</div>
              <h2 style={{ margin: "0.35rem 0" }}>{t("gate.familyTitle")}</h2>
              <p style={{ margin: 0 }}>{t("gate.familyBody")}</p>
            </div>
            <div className="anno">{t("gate.familyCta")}</div>
          </Link>
          <Link to={pathKeepingDebug("/signin", search, { role: "staff" })}>
            <div>
              <div className="meta">{t("gate.staffMeta")}</div>
              <h2 style={{ margin: "0.35rem 0" }}>{t("gate.staffTitle")}</h2>
              <p style={{ margin: 0 }}>{t("gate.staffBody")}</p>
            </div>
            <div className="anno">
              {showDevShortcuts ? `${staff.given} ${staff.family} · ` : ""}
              {t("gate.familyCta")}
            </div>
          </Link>
        </div>
        <p className="auth-links">
          <Link to="/signup">{t("gate.createAccount")}</Link>
          <Link to="/forgot-password">{t("gate.forgot")}</Link>
          {showDevShortcuts ? <Link to="/harness">Test harness</Link> : null}
        </p>
      </main>
    </div>
  );
}
